import { useContext } from "react";
import UserContext from "../../contexts/UserContext.js";
import MenuCalendar from "./MenuCalendar.jsx";
import MenuList from "./MenuList.jsx";

const Menu = () => {
    const { user } = useContext(UserContext);
    
    // Show calendar for admins, list for regular users
    if (user && user.role === 'admin') {
        return <MenuCalendar />;
    } else {
        return <MenuList />;
    }
};

export default Menu;